<template>
  <BlogPostContainer>
    <template #preventPageTitle>
      {{ post?.title?.rendered || '' }}
    </template>

    <template #banner>
      <img v-if="postStatus === 'success'" :src="post?.featured_image_url || '/images/topPost.webp'">
    </template>

    <template #postTitle>
      {{ post?.title?.rendered || '' }}
    </template>

    <template #date>
      {{ date }}
    </template>

    <template #content>
      <div 
        v-if="post?.content?.rendered"
        v-html="post.content.rendered"
      />
    </template>

    <template #recent>
      <BlogRecentPosts
        :loading="recentPostLoader"
        :posts="recentPosts"
      />
    </template>

    <template #subscr>
      <Subscribe />
    </template>
  </BlogPostContainer>
</template>

<script setup lang="ts">
import { resolveLocalizedPost } from '~/utils/wordpress';

const route = useRoute();
const { locale } = useI18n();
const localePath = useLocalePath();

const { $moment } = useNuxtApp();
const date = computed<string>(() => post.value?.date ? $moment(post.value.date).format('DD.MM.YYYY') : '');

const getPost = async (): Promise<Record<any, any> | null> => {
  return resolveLocalizedPost({
    id: String(route.params._id),
    locale: locale.value,
    localizedPath: id => localePath(`/blog/${id}`),
    responseFormat: 'wp',
  });
};

const getRecentPosts = async (postId?: string | number): Promise<Record<any, any>[]> => {
  if (!postId) {
    return [];
  }

  try {
    const response = await fetch(`https://wp.0detect.com/wp-json/wp/v2/posts?meta_key=lang&meta_value=${locale.value}&exclude=${postId}&per_page=3`, {
      method: 'GET',
    });

    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
};

const { data: post, status: postStatus } = useAsyncData(
  'blog-post',
  () => getPost(),
  {
    watch: [locale, () => route.params._id],
    server: true,
    lazy: false,
    default: () => null,
  },
);

const { data: recentPosts, status: recentPostLoader } = useAsyncData(
  'blog-recent',
  () => getRecentPosts(post.value?.id),
  {
    watch: [locale, () => post.value?.id],
    server: true,
    lazy: false,
    default: () => [],
  },
);
</script>
